import React from "react";
import { PageLayout } from "./Layouts/PageLayout";
import UserState from "./Components/User/UserState";
import { SnackbarProvider } from "notistack";

export default function App() {
    return (
		<UserState>
			<SnackbarProvider maxSnack={1}>
				<PageLayout />
			</SnackbarProvider>
		</UserState>
	);
}
